import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { ProfilePageBannerMutationKeys } from '../../../keys'
import {
	CreateProfilePageBannerRequest,
	CreateProfilePageBannerResponse,
} from '../../../type'
import { createProfilePageBanner } from '../../services'

interface UseMutationCreateProfilePageBannerProps {
	payload: CreateProfilePageBannerRequest
}

export default function useMutationCreateProfilePageBanner(
	props?: UseBaseMutationOptions<
		CreateProfilePageBannerResponse,
		UseMutationCreateProfilePageBannerProps
	>,
) {
	return useMutation({
		mutationKey: [ProfilePageBannerMutationKeys.CreateProfilePageBanner],
		mutationFn: (params) => createProfilePageBanner(params.payload),
		...props,
	})
}
